import IFolderFormProps from "../IFolderFormProps";
import { SelectTabData, SelectTabEvent, Tab, TabList, TabValue } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import useStyleUtils from "../../../utilities/styles";

interface IFolderFormTabsProps extends IFolderFormProps {
    selectedTab: TabValue;
    onTabChange: (tab: string) => void;
}

export default function Tabs(props: IFolderFormTabsProps) {        
    const { t } = useTranslation();

    const style = useStyleUtils();

    const handleTabSelect = (_: SelectTabEvent, data: SelectTabData) => props.onTabChange(data.value as string);

    return (
        <TabList selectedValue={props.selectedTab} onTabSelect={handleTabSelect} className={style.mb3}>
            <Tab value="tab-details">
                {t("folders.form.sections.details")}
            </Tab>
            <Tab value="tab-audience">
                {t("folders.form.sections.audience")}
            </Tab>
            <Tab value="tab-attributes">
                {t("folders.form.sections.attributes")}
            </Tab>
        </TabList>
    );
}